export default "__VITE_ASSET__BGeTXVW6__"